import type { ImpressionServerEvent } from './ImpressionEvent';

const FLUSH_DELAY_MS = 1000;

let queue: ImpressionServerEvent[] = [];
let flushTimer: ReturnType<typeof setTimeout> | undefined;
let unloadFlushAttached = false;
const seen = new Set<string>();

function dedupeKey({ data }: ImpressionServerEvent, dedupeId?: string) {
  const identity = dedupeId ?? JSON.stringify(data.impression_properties);

  return `${data.view_id}|${data.impression_type}|${identity}`;
}

function flush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = undefined;
  }

  if (!queue.length) return;

  const events = queue;
  queue = [];

  void fetch('/bolt/event', {
    body: JSON.stringify({ events }),
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    method: 'POST'
  }).catch(() => undefined);
}

function attachUnloadFlush() {
  if (unloadFlushAttached || typeof document === 'undefined') return;

  unloadFlushAttached = true;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
}

export function enqueueImpression(
  event: ImpressionServerEvent,
  dedupeId?: string
) {
  const key = dedupeKey(event, dedupeId);

  if (seen.has(key)) return;

  seen.add(key);
  queue.push(event);
  attachUnloadFlush();

  if (!flushTimer) flushTimer = setTimeout(flush, FLUSH_DELAY_MS);
}
